import { render } from "./forbidden-page.vue?vue&type=template&id=60bfce44&ts=true"
import script from "./forbidden-page.vue?vue&type=script&lang=ts"
export * from "./forbidden-page.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__